// src/components/RightPanel/RightFooter.js
import React from 'react';
import LearnMoreLink from '../elements/LearnMoreLink';

const RightFooter = () => {
  return (
    <div className="p-2 bg-gray-100 text-xs text-gray-500 flex flex-col items-center">
      <div className="text-center mt-1">
        <span>Waybee is still learning. Please verify info.</span>
        <LearnMoreLink />
      </div>
    </div>
  );
};

export default RightFooter;
